import React from "react";
import styled from "styled-components";
// Components
import ProjectBox from "../Elements/ProjectBox";
import FullButton from "../Buttons/FullButton";
// Assets
import ProjectImg1 from "../../assets/img/projects/project7.webp";
import ProjectImg2 from "../../assets/img/projects/project13.webp";
import ProjectImg3 from "../../assets/img/projects/project10.webp";
import ProjectImg4 from "../../assets/img/projects/project15.webp";
import ProjectImg5 from "../../assets/img/projects/project8.webp";
import ProjectImg6 from "../../assets/img/projects/project0.webp";
import AddImage2 from "../../assets/img/add/guide6.webp";

export default function Projects() {
  return (
    <Wrapper id="projects">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">What We Can Do</h1>
            <p className="font13">
              Explore the range of services Kupeel offers to bring innovative audio content to life in museums and beyond.
              <br />
              See how Kupeel can transform visitor experiences through immersive audio guides.
            </p>
          </HeaderInfo>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg1}
                title="Historical Museum"
                text="Create engaging audio guides for historical exhibits."
                action={() => window.location.href = 'https://play.kupeel.com'}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg2}
                title="Art Gallery"
                text="Enhance art appreciation through descriptive audio content."
                action={() => window.location.href = 'https://play.kupeel.com'}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg3}
                title="Science Center"
                text="Develop interactive audio guides for science and technology exhibits."
                action={() => window.location.href = 'https://play.kupeel.com'}
              />
            </div>
          </div>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg4}
                title="Children's Museum"
                text="Produce fun and educational audio guides for young visitors."
                action={() => window.location.href = 'https://play.kupeel.com'}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg5}
                title="Cultural Center"
                text="Create audio content that brings cultural exhibits to life."
                action={() => window.location.href = 'https://play.kupeel.com'}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg6}
                title="Outdoor Historical Site"
                text="Develop guided tours with immersive audio descriptions."
                action={() => window.location.href = 'https://play.kupeel.com'}
              />
            </div>
          </div>
          <div className="row flexCenter">
            <div style={{ margin: "50px 0", width: "200px" }}>
              {/* <FullButton title="Learn More" action={() => window.location.href = 'https://play.kupeel.com'} /> */}
            </div>
          </div>
        </div>
      </div>
      <div className="lightBg">
        <div className="container">
          <Advertising className="flexSpaceCenter">
            <AddLeft>
              <AddLeftInner>
                <ImgWrapper className="flexCenter">
                  <img className="radius8" src={AddImage2} alt="add" />
                </ImgWrapper>
              </AddLeftInner>
            </AddLeft>
            <AddRight>
              <h4 className="font15 semiBold">About Kupeel</h4>
              <h2 className="font40 extraBold">Innovative Audio Solutions</h2>
              <p className="font12">
                Kupeel specializes in creating high-quality, engaging audio content for museums and cultural institutions.
                <br />
                Our mission is to enhance visitor experiences through cutting-edge audio guides and immersive storytelling.
              </p>
              <ButtonsRow className="flexNullCenter" style={{ margin: "30px 0" }}>
  <div style={{ width: "190px" }}>
    <FullButton
      title="Get Started"
      action={() => window.location.href = 'https://play.kupeel.com'}
    />
  </div>
  <div style={{ width: "190px", marginLeft: "15px" }}>
    <FullButton
      title="Contact Us"
      action={() => window.location.hash = 'contact'}
      border
    />
  </div>
</ButtonsRow>

            </AddRight>
          </Advertising>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Advertising = styled.div`
  padding: 100px 0;
  margin: 100px 0;
  position: relative;
  @media (max-width: 1160px) {
    padding: 60px 0 40px 0;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 80px 0 0px 0;
  }
`;
const ButtonsRow = styled.div`
  @media (max-width: 860px) {
    justify-content: space-between;
  }
`;
const AddLeft = styled.div`
  position: relative;
  width: 50%;
  p {
    max-width: 475px;
  }
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
    text-align: center;
    h2 {
      line-height: 3rem;
      margin: 15px 0;
    }
    p {
      margin: 0 auto;
    }
  }
`;
const AddRight = styled.div`
  width: 50%;
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
  }
`;
const AddLeftInner = styled.div`
  width: 100%;
  position: absolute;
  top: -300px;
  left: 0;
  @media (max-width: 1190px) {
    top: -250px;
  }
  @media (max-width: 920px) {
    top: -200px;
  }
  @media (max-width: 860px) {
    order: 1;
    position: relative;
    top: -60px;
    left: 0;
  }
`;
const ImgWrapper = styled.div`
  width: 100%;
  padding: 0 15%;
  img {
    width: 100%;
    height: auto;
  }
  @media (max-width: 400px) {
    padding: 0;
  }
`;
